import { useQuery } from '@tanstack/react-query';
import { getEnvironment } from '../api/endpoints/plant';

export function useEnvironment() {
  return useQuery({ queryKey: ['environment'], queryFn: getEnvironment, refetchInterval: 60_000 });
}
